module.exports = "/assets/b972bd3d1302504095588107fee253f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9K.png
// module id = 2293
// module chunks = 0